import api, { HEADERS } from '~config/api';

export async function getCertificate() {
  const tenant = api.headers[HEADERS.TENANT];
  const response = await fetch(`${process.env.REACT_APP_PUBLIC_CDN}${tenant}/qz_certs/cert.pem`);
  if (response.ok) {
    return response.text();
  }
  throw new Error();
}

export async function getSignature(toSign) {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/v1/admin/qz/sign`, {
    method: 'POST',
    headers: { ...api.headers },
    body: JSON.stringify({ to_sign: toSign })
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error();
}
